import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES } from '../constants/theme';
import './ModernFooter.css';

const Footer = () => {
  return (
    <footer className="modern-footer">
      {/* Top section */}
      <div className="footer-top">
        <div className="container">
          <div className="row g-4">
            {/* Brand */}
            <div className="col-12 col-lg-4">
              <div className="footer-brand">
                <Link to="/" className="footer-logo">
                  <img src="https://senoffre.com/storage/app/logo/thumb-1500x1500-logo-dark-67dc8fcc93998.png" alt="Senoffre" />
                </Link>
                <p className="footer-desc">
                  SenOffre est la plateforme numérique sénégalaise dédiée à la diffusion des appels d’offres, demandes de prix, avis de consultation et opportunités de marchés publics et privés.
                </p>
                <div className="socials">
                  <a href="#" aria-label="Facebook" className="social-btn fb"><i className="fa-brands fa-facebook-f" /></a>
                  <a href="#" aria-label="X" className="social-btn x"><i className="fa-brands fa-x-twitter" /></a>
                  <a href="#" aria-label="Instagram" className="social-btn ig"><i className="fa-brands fa-instagram" /></a>
                  <a href="#" aria-label="LinkedIn" className="social-btn li"><i className="fa-brands fa-linkedin-in" /></a>
                </div>
              </div>
            </div>

            {/* Links */}
            <div className="col-6 col-lg-2">
              <div className="footer-col">
                <h5 className="footer-title">Navigation</h5>
                <ul className="footer-links">
                  <li><Link to="/">Accueil</Link></li>
                  <li><Link to="/posts">Offres</Link></li>
                  <li><Link to="/pricing">Tarifs</Link></li>
                  <li><Link to="/contact-us">Contact</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-6 col-lg-3">
              <div className="footer-col">
                <h5 className="footer-title">Catégories</h5>
                <ul className="footer-links">
                  <li><Link to="/posts?cat=BTP">BTP</Link></li>
                  <li><Link to="/posts?cat=Fournitures%20courantes">Fournitures courantes</Link></li>
                  <li><Link to="/posts?cat=Prestations%20intellectuelles">Prestations intellectuelles</Link></li>
                  <li><Link to="/posts?cat=Informatique%20%26%20Télécoms">Informatique & Télécoms</Link></li>
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="col-12 col-lg-3">
              <div className="footer-col newsletter">
                <h5 className="footer-title">Rester informé</h5>
                <p className="newsletter-desc">Recevez chaque semaine les dernières offres correspondant à votre domaine d’activité.</p>
                <form className="newsletter-form" onSubmit={(e)=>e.preventDefault()}>
                  <div className="input-wrap">
                    <i className="fa-regular fa-envelope"></i>
                    <input type="email" required placeholder="Votre adresse email" aria-label="Email" />
                    <button type="submit" className="btn-submit">S'abonner</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Decorative gradient blur */}
        <div className="footer-glow"></div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="bottom-inner">
            <p className="copyright"> {new Date().getFullYear()} Senoffre. Tous droits réservés.</p>
            <ul className="legal-links">
              <li><Link to="#">Confidentialité</Link></li>
              <li><Link to="#">Conditions</Link></li>
              <li><Link to="#">Cookies</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;